import TicketsStatusApi from '../../../../services/api/ticketsStatusApi'

/* Service class used to perform api calls for dealing with ticket state updates */
class TicketStateService {
    constructor() {
        this._api = TicketsStatusApi.create();
    }

    api() {
        return this._api;
    }

    async updateTicketState(ticket, newTicketState, reasonIdentifier) {
        try {
            var payload = {
                associateId: ticket.associateId,
                ticketState: newTicketState,
                stateTransitionReason: reasonIdentifier,
                taxYear: ticket.taxYear,
                nameEn: ticket.name.en,
                nameFr: ticket.name.fr,
                workflowIdentifier: ticket.workflow.identifier,
                ticketTypeIdentifier: ticket.ticketType.identifier,
                officeId: ticket.officeId,
                failOnInvalidAssignment: true
            };

            var response = await this.api().updateTicket(ticket.id, payload);
            if (response && response.ok) {
                return response.data
            } 
        } catch (ex) {
            console.log("failed to update the ticket", ex)
        } 
        return null;
    }

    /**
     * Retrieves all available ticket status change reasons
     * @param {any} ticketType
     * @ticketType
     */
    async getReasons(ticketType) {
        try {            
            var response = await this.api().getTicketStatusReasons(ticketType)
            if (response && response.ok) {
                return response.data
            } 
        } catch (ex) {
            console.log("failed to retrieve ticket status reasons", ex)
        } 
        return null;
    }
}

const ticketStateService = new TicketStateService();
export default ticketStateService;